// get code from https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/

// Your personal API key.
// Get it here: https://console.cloud.google.com/google/maps-apis
// const API_KEY = 'AIzaSyAwZbYPVaJWwTuGOBeg3-LXVp4-jJY0e_M'; // Jeff's Key
const API_KEY = 'AIzaSyDMFPf0rpnQpSrLttYmrRbxfQzT-otS3uc';  //hmwebquote@gmail.com key
const CALLBACK_NAME = 'gmapsCallback';

let initialized = !!window.google;
let resolveInitPromise;
let rejectInitPromise;
// This promise handles the initialization
// status of the google maps script.
const initPromise = new Promise((resolve, reject) => {
  resolveInitPromise = resolve;
  rejectInitPromise = reject;
});

export default function init() {
  // If Google Maps already is initialized
  // the `initPromise` should get resolved
  // eventually.
  if (initialized) return initPromise;

  initialized = true;
  // The callback function is called by
  // the Google Maps script if it is
  // successfully loaded.
  window[CALLBACK_NAME] = () => resolveInitPromise(window.google);

  // We inject a new script tag into
  // the `<head>` of our HTML to load
  // the Google Maps script.
  const script = document.createElement('script');
  script.async = true;
  script.defer = true;
  script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=${CALLBACK_NAME}`;
  script.onerror = rejectInitPromise;
  document.querySelector('head').appendChild(script);

  //import utility lib 
  // const script2 = document.createElement('script');
  // // script2.async = true;
  // // script2.defer = true;
  // script2.src = `https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/archive/infobox/src/infobox_packed.js`;
  // script2.onerror = rejectInitPromise;
  // document.querySelector('head').appendChild(script2);

  return initPromise;
}